import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LayoutService } from 'src/app/shared/services/layout/layout.service';

@Directive({
  selector: '[isDesktop]',
  standalone: true,
})
export class IsDesktopDirective implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);
  private readonly elementRef = inject(ElementRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly templateReference = inject(TemplateRef<unknown>);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly layoutService = inject(LayoutService);

  embeddedView!: EmbeddedViewRef<unknown>;

  ngOnInit(): void {
    this.calculateView(this.layoutService.isDesktop);
    this.breakpointListener();
  }

  private breakpointListener(): void {
    this.layoutService.onBreakpointChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.calculateView(this.layoutService.isDesktop);
        this.changeDetectorRef.markForCheck();
      });
  }

  private calculateView(match: boolean): void {
    if (match) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateReference);

      return;
    }

    this.viewContainerRef.clear();
  }

  ngOnDestroy(): void {
    if (this.embeddedView) {
      this.embeddedView.destroy();
    }

    if (this.viewContainerRef) {
      this.viewContainerRef.clear();
      this.viewContainerRef.detach();
    }

    const nativeElement = this.elementRef.nativeElement;

    if (nativeElement && nativeElement.parentNode) {
      nativeElement.parentNode.removeChild(nativeElement);
    }
  }
}
